import { NgIf } from '@angular/common';

import { afterNextRender, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PrimeNGModule } from '../../../primeng.module';
import { CookieConsentService } from '../../../services/cookie-consent/cookie-consent.service';
import { WhatsAppService } from '../../../services/whats-app/whats-app.service';
import { Product } from '../../models/product/product';
import { SharedModule } from '../../shared.module';
import { WhatsAppComponent } from '../whats-app/whats-app.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgIf, WhatsAppComponent, PrimeNGModule, SharedModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnDestroy {
  @Input() justRights: boolean = false;

  public static readonly COOKIE_PRIVACY = 'cookie_accept_policy';
  public static readonly COOKIE_PRIVACY_FULL =
    'cookie_accept_policy=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/';

  public showWhatsApp = false;
  public hasConsent = false;

  public subscribeData = {
    email: '',
    name: '',
    phone: '',
  };

  public productWhatsApp?: Product | null;
  private subscriptionWhatsProduct?: Subscription;
  private subscriptionWhats?: Subscription;

  constructor(
    private whatsAppService: WhatsAppService,
    private consentService: CookieConsentService
  ) {
    afterNextRender(() => {
      this.init();
    });
  }

  async init() {
    this.hasConsent = await this.consentService.hasConsent();
    //if (this.hasConsent) {
    //  this.loadTrackingScripts();
    //}

    this.loadTrackingScripts();

    this.subscriptionWhatsProduct = this.whatsAppService
      .getOpenWhatsAppProduct()
      .subscribe(async (product: any) => {
        if (product) {
          this.productWhatsApp = product;
          this.showWhatsApp = true;
        } else {
          this.productWhatsApp = null;
        }
      });

    this.subscriptionWhats = this.whatsAppService
      .getOpenWhatsApp()
      .subscribe(async (show: boolean) => {
        this.showWhatsApp = show;
      });
  }

  onClickCookies() {
    this.consentService.giveConsent();
    this.hasConsent = true;
    location.reload();
  }

  onClickbtnCloseWhats() {
    this.whatsAppService.setOpenWhatsAppProduct(null);
    this.showWhatsApp = false;
  }

  onClickbtnWhats() {
    this.whatsAppService.setOpenWhatsAppProduct(null);
    this.showWhatsApp = !this.showWhatsApp;
  }

  ngOnDestroy() {
    this.subscriptionWhatsProduct?.unsubscribe();
    this.subscriptionWhats?.unsubscribe();
  }

  loadTrackingScripts() {
    // Google Tag Manager
    const gtm = document.createElement('script');
    gtm.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-WKP588W');`;
    document.head.appendChild(gtm);

    // Google Analytics
    const gaScript = document.createElement('script');
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-N22C0TZH8C';
    gaScript.async = true;
    document.head.appendChild(gaScript);

    const gaConfig = document.createElement('script');
    gaConfig.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-N22C0TZH8C');
    `;
    document.head.appendChild(gaConfig);
  }
}
